module.exports = {
  default: {
    title: "Default",
    menus: [],
  },
  adminMenu: {
    title: "ADMIN",
    menus: [
      {
        id: 0,
        name: "Dashboard",
        icon: "structure",
        parent: "",
        path: "/admin-dashboard",
      },
      // Home Page Management
      {
        id: 3,
        name: "Home Page Management",
        parent: "",
        child: true,
        icon: "house",
      },
      // About KSPACE
      {
        id: 7,
        name: "About KSPACE",
        parent: 3,
        icon: "about",
        child: true,
      },
      {
        id: 51,
        path: "/maintext-list",
        icon: "maintext",
        name: "Main Text",
        parent: 7,
      },
      {
        id: 52,
        path: "/organization-list",
        icon: "structure",
        name: "Organizational Structure",
        parent: 7,
      },
      {
        id: 8,
        path: "/quotes-list",
        icon: "quote",
        name: "Messages",
        parent: 7,
      },
      {
        id: 6,
        path: "/scope-activity-list",
        icon: "activity",
        name: "Scope of Activities",
        parent: 7,
      },
      {
        id: 9,
        path: "/accomplishment-list",
        icon: "flag",
        name: "Our Accomplishments",
        parent: 7,
      },
      // Home Page
      {
        id: 301,
        name: "Home Page",
        parent: 3,
        icon: "house",
        child: true,
      },
      {
        id: 4,
        icon: "slide",
        path: "/banner-list",
        name: "Banner Images/Videos",
        parent: 301,
      },
      {
        id: 5,
        path: "/scrolling-list",
        icon: "bell",
        name: "Scrolling Notification",
        parent: 301,
      },
      {
        id: 107,
        path: "/advertisement-list",
        icon: "flag",
        name: "Advertisement",
        parent: 301,
      },
      {
        id: 66,
        path: "/news-list",
        icon: "application",
        name: "News and Updates",
        parent: 301,
      },
      // List of Companies
      {
        id: 11,
        name: "List of Companies",
        parent: "",
        icon: "company",
        child: true,
      },
      {
        id: 15,
        name: "Existing Aerospace Companies Affiliated with KSPACE",
        path: "/kerala-companies-list",
        icon: "companylist",
        parent: 11,
      },
      {
        id: 21,
        name: "KSPACE Premises",
        icon: "companylist",
        path: "/company-request-list/kspace",
        parent: 11,
      },
      {
        id: 211,
        name: "Own Premises",
        icon: "companylist",
        path: "/company-request-list/own",
        parent: 11,
      },
      {
        id: 18,
        name: "Indian Companies",
        icon: "companylist",
        path: "/india-companies-list",
        parent: 11,
      },
      {
        id: 212,
        name: "International Companies",
        icon: "companylist",
        path: "/international-companies-list",
        parent: 11,
      },
      {
        id: 213,
        name: "On-going Projects in KSPACE Premises",
        icon: "activity",
        path: "/admin-directory-kspace/kspace",
        parent: 11,
      },
      {
        id: 214,
        name: "On-going Projects in Own Premises",
        icon: "activity",
        path: "/admin-directory-kspace/own",
        parent: 11,
      },
      {
        id: 215,
        name: "Completed Projects in KSPACE Premises",
        icon: "book",
        path: "/admin-directory-kspace/completed-kspace",
        parent: 11,
      },
      {
        id: 216,
        name: "Completed Projects in Own Premises",
        icon: "book",
        path: "/admin-directory-kspace/completed-own",
        parent: 11,
      },
      // Area Management
      {
        id: 2,
        name: "Area Management",
        icon: "areamanage",
        parent: "",
        child: true,
      },
      {
        id: 83,
        name: "Built-Up Space Category",
        icon: "areamanage",
        parent: 2,
        path: "/area-types",
      },
      {
        id: 84,
        name: "Building & Floor Details",
        icon: "areamanage",
        parent: 2,
        path: "/rent-area",
      },
      {
        id: 85,
        name: "Built-Up Space Allocation Details",
        icon: "areamanage",
        parent: 2,
        path: "/space-allocation-details",
      },
      {
        id: 86,
        name: "Land Allocation Details",
        icon: "areamanage",
        parent: 2,
        path: "/land-allocation-details",
      },
      {
        id: 80,
        name: "Built-Up Space/Land in KSPACE Premises",
        icon: "areamanage",
        parent: 2,
        path: "/builtup-space",
      },
      // Association with Professional Bodies / Institutions
      {
        id: 38,
        name: "Association with Professional Bodies / Institutions",
        icon: "academic",
        parent: "",
        child: true,
      },
      {
        id: 39,
        path: "/academicinstitution-list",
        icon: "application",
        name: "Academic Institutions",
        parent: 38,
      },
      {
        id: 42,
        path: "/institutionproposal-list",
        icon: "directory",
        name: "Student Project Proposal",
        parent: 38,
      },
      // Master Data Table
      {
        id: 10,
        name: "Master Data Table",
        parent: "",
        icon: "book",
        child: true,
      },
      {
        id: 101,
        path: "/domain-list",
        icon: "technology",
        name: "Domains (Area of Operations)",
        parent: 10,
      },
      {
        id: 102,
        path: "/qualifications-list",
        icon: "academic",
        name: "Educational Qualification",
        parent: 10,
      },
      {
        id: 103,
        path: "/tenderCategory-list",
        icon: "companylist",
        name: "Tender Category List",
        parent: 10,
      },
      {
        id: 104,
        path: "/tenderOrganization-list",
        icon: "company",
        name: "Tender Organization List",
        parent: 10,
      },
      {
        id: 105,
        path: "/techo-transfer-category-list",
        icon: "companylist",
        name: "Technology Transfer Category List",
        parent: 10,
      },
      {
        id: 106,
        path: "/techo-transfer-organization-list",
        icon: "company",
        name: "Technology Transfer Organisations List",
        parent: 10,
      },
      // KSPACE Related
      {
        id: 450,
        name: "KSPACE Related",
        parent: "",
        icon: "about",
        child: true,
      },
      {
        id: 45,
        icon: "advisors",
        path: "/advisors-list",
        name: "Spacepark Advisors",
        parent: 450,
      },
      {
        id: 23,
        path: "/resource-list",
        name: "Resource Personnel",
        icon: "resource",
        parent: 450,
      },
      {
        id: 26,
        path: "/manpower-list",
        name: "Expert Manpower",
        parent: 450,
        icon: "expert",
      },
      {
        id: 30,
        path: "/tender-list",
        icon: "application",
        name: "Tender Notices",
        parent: 450,
      },
      {
        id: 63,
        path: "/career-list",
        icon: "application",
        name: "Career Opportunities",
        parent: 450,
      },
      {
        id: 64,
        path: "/policies-list",
        name: "Policies and Regulations",
        parent: 450,
        icon: "application",
      },
      {
        id: 65,
        path: "/incentives-list",
        name: "Financial Support and Incentives",
        parent: 450,
        icon: "resource",
      },
      {
        id: 70,
        icon: "advisors",
        path: "/faq-list",
        name: "FAQ",
        parent: 450,
      },
      // Market Research
      {
        id: 29,
        name: "Market Research",
        icon: "market",
        parent: "",
        child: true,
      },
      {
        id: 40,
        path: "/trade-list",
        icon: "application",
        name: "Trade Enquiries",
        parent: 29,
      },
      {
        id: 31,
        path: "/publication-list",
        icon: "activity",
        name: "Publications",
        parent: 29,
      },
      {
        id: 34,
        path: "/transfer-proposal-list",
        icon: "technology",
        name: "Technology Transfer Proposals",
        parent: 29,
      },
      {
        id: 680,
        name: "Challenges / Opportunities",
        icon: "ideas",
        parent: 29,
        child: true,
      },
      {
        id: 681,
        path: "/challenges-add",
        icon: "ideas",
        name: "Add Challenge/Opportunity Headline",
        parent: 680,
      },
      {
        id: 682,
        path: "/challenges",
        icon: "ideas",
        name: "List of Challenges/Opportunities",
        parent: 680,
      },
      {
        id: 683,
        path: "/market-analysis",
        name: "Market Analysis",
        icon: "market",
        parent: 680,
      },
      // Internship
      {
        id: 87,
        name: "Internship",
        icon: "company",
        parent: "",
        child: true,
      },
      {
        id: 88,
        path: "/admin-internship-requests",
        icon: "news",
        name: "Requests : Companies",
        parent: 87,
      },
      {
        id: 89,
        path: "/admin-internship-applications",
        icon: "application",
        name: "Applications : Students",
        parent: 87,
      },
      {
        id: 94,
        path: "/admin-previous-applications",
        icon: "application",
        name: "Previous Applications",
        parent: 87,
      },
      {
        id: 91,
        path: "/admin-internships-doing",
        icon: "activity",
        name: "Directory of Internships Doing",
        parent: 87,
      },
      {
        id: 92,
        path: "/admin-internships-completed",
        icon: "book",
        name: "Directory of Internships Completed",
        parent: 87,
      },
      {
        id: 93,
        path: "/admin-internships-absorbed",
        icon: "resource",
        name: "Directory of Internships Absorbed",
        parent: 87,
      },
      {
        id: 95,
        path: "/admin-internship-visualization",
        icon: "analytics",
        name: "Internship Visualization",
        parent: 87,
      },
      // Jobseekers
      {
        id: 27,
        name: "Jobseekers",
        parent: "",
        child: true,
        icon: "directory",
      },
      {
        id: 271,
        path: "/candidates-list/registry",
        name: "Job Seeker Registry",
        parent: 27,
        icon: "directory",
      },
      {
        id: 28,
        path: "/profiles-list",
        name: "Job Seeker Profiles Downloaded by Companies",
        parent: 27,
        icon: "resource",
      },
      {
        id: 272,
        path: "/candidates-list/employed",
        name: "Job Seekers Employed through KSPACE",
        parent: 27,
        icon: "directory",
      },
      {
        id: 273,
        path: "/candidates-list/inactive",
        name: "Inactive Job Seeker Registrations",
        parent: 27,
        icon: "directory",
      },
      {
        id: 274,
        path: "/candidates-list/optedout",
        name: "Job Seekers Opted-Out",
        parent: 27,
        icon: "directory",
      },
      // Business Ideas
      {
        id: 32,
        name: "Business Ideas",
        icon: "ideas",
        parent: "",
        child: true,
      },
      {
        id: 661,
        icon: "advisors",
        path: "/vendors-list",
        name: "Vendors",
        parent: 32,
      },
      {
        id: 33,
        path: "/project-proposal-list",
        icon: "proposals",
        name: "Business Proposals",
        parent: 32,
      },
      // Events
      {
        id: 46,
        name: "Events",
        icon: "events",
        parent: "",
        child: true,
      },
      {
        id: 461,
        name: "KSPACE Events",
        icon: "events",
        parent: 46,
        child: true,
      },
      {
        id: 471,
        icon: "eventlist",
        name: "Event List",
        path: "/event-list-kspace",
        parent: 461,
      },
      {
        id: 48,
        icon: "book",
        name: "Registrations",
        path: "/event-booking",
        parent: 461,
      },
      {
        id: 462,
        name: "Other Events",
        icon: "events",
        parent: 46,
        child: true,
      },
      {
        id: 472,
        icon: "eventlist",
        name: "Event List",
        path: "/event-list-others",
        parent: 462,
      },
      // Our Partners
      {
        id: 500,
        name: "Our Partners",
        icon: "people",
        parent: "",
        child: true,
      },
      {
        id: 50,
        icon: "advisors",
        path: "/admin-mou",
        name: "MoUs",
        parent: 500,
      },
      {
        id: 651,
        icon: "advisors",
        path: "/membership",
        name: "Memberships",
        parent: 500,
      },
      // Gallery
      {
        id: 49,
        icon: "slide",
        name: "Gallery",
        path: "",
        child: true,
        parent: "",
      },
      {
        id: 61,
        icon: "slide",
        name: "Images",
        path: "/images",
        parent: 49,
      },
      {
        id: 62,
        icon: "slide",
        name: "Videos",
        path: "/videos",
        parent: 49,
      },
      // Bulk Email
      {
        id: 90,
        icon: "mail",
        path: "/bulk-emails",
        name: "Bulk Email",
        parent: "",
      },
      // Analytics
      {
        id: 900,
        name: "Analytics",
        icon: "settings",
        parent: "",
        child: true,
      },
      {
        id: 901,
        path: "/login-analytics",
        icon: "analytics",
        name: "Login Analytics",
        parent: 900,
      },
      {
        id: 902,
        path: "/login-logs",
        icon: "database",
        name: "Login Logs",
        parent: 900,
      },
    ],
  },
  intMdAdminMenu: {
    title: "ADMIN",
    menus: [
      {
        id: 0,
        name: "Dashboard",
        icon: "structure",
        parent: "",
        path: "/admin-dashboard",
      },
      // Home Page Management
      {
        id: 3,
        name: "Home Page Management",
        parent: "",
        child: true,
        icon: "house",
      },
      // About KSPACE
      {
        id: 7,
        name: "About KSPACE",
        parent: 3,
        icon: "about",
        child: true,
      },
      {
        id: 51,
        path: "/maintext-list",
        icon: "maintext",
        name: "Main Text",
        parent: 7,
      },
      {
        id: 52,
        path: "/organization-list",
        icon: "structure",
        name: "Organizational Structure",
        parent: 7,
      },
      {
        id: 8,
        path: "/quotes-list",
        icon: "quote",
        name: "Messages",
        parent: 7,
      },
      {
        id: 6,
        path: "/scope-activity-list",
        icon: "activity",
        name: "Scope of Activities",
        parent: 7,
      },
      {
        id: 9,
        path: "/accomplishment-list",
        icon: "flag",
        name: "Our Accomplishments",
        parent: 7,
      },
      // Home Page
      {
        id: 301,
        name: "Home Page",
        parent: 3,
        icon: "house",
        child: true,
      },
      {
        id: 4,
        icon: "slide",
        path: "/banner-list",
        name: "Banner Images/Videos",
        parent: 301,
      },
      {
        id: 5,
        path: "/scrolling-list",
        icon: "bell",
        name: "Scrolling Notification",
        parent: 301,
      },
      {
        id: 107,
        path: "/advertisement-list",
        icon: "flag",
        name: "Advertisement",
        parent: 301,
      },
      // List of Companies
      {
        id: 11,
        name: "List of Companies",
        parent: "",
        icon: "company",
        child: true,
      },
      {
        id: 21,
        name: "KSPACE Premises",
        icon: "companylist",
        path: "/company-request-list/kspace",
        parent: 11,
      },
      {
        id: 211,
        name: "Own Premises",
        icon: "companylist",
        path: "/company-request-list/own",
        parent: 11,
      },
      {
        id: 18,
        name: "Indian Companies",
        icon: "companylist",
        path: "/india-companies-list",
        parent: 11,
      },
      {
        id: 212,
        name: "International Companies",
        icon: "companylist",
        path: "/international-companies-list",
        parent: 11,
      },
      // Area Management
      {
        id: 2,
        name: "Area Management",
        icon: "areamanage",
        parent: "",
        child: true,
      },
      {
        id: 80,
        name: "Built-Up Space/Land in KSPACE Premises",
        icon: "areamanage",
        parent: 2,
        path: "/builtup-space",
      },
      // Master Data Table
      {
        id: 10,
        name: "Master Data Table",
        parent: "",
        icon: "book",
        child: true,
      },
      {
        id: 101,
        path: "/domain-list",
        icon: "technology",
        name: "Domains (Area of Operations)",
        parent: 10,
      },
      {
        id: 102,
        path: "/qualifications-list",
        icon: "academic",
        name: "Educational Qualification",
        parent: 10,
      },
      // KSPACE Related
      {
        id: 450,
        name: "KSPACE Related",
        parent: "",
        icon: "about",
        child: true,
      },
      {
        id: 30,
        path: "/tender-list",
        icon: "application",
        name: "Tender Notices",
        parent: 450,
      },
      // Market Research
      {
        id: 29,
        name: "Market Research",
        icon: "market",
        parent: "",
        child: true,
      },
      {
        id: 40,
        path: "/trade-list",
        icon: "application",
        name: "Trade Enquiries",
        parent: 29,
      },
      {
        id: 31,
        path: "/publication-list",
        icon: "activity",
        name: "Publications",
        parent: 29,
      },
      // Business Ideas
      {
        id: 32,
        name: "Business Ideas",
        icon: "ideas",
        parent: "",
        child: true,
      },
      {
        id: 661,
        icon: "advisors",
        path: "/vendors-list",
        name: "Vendors",
        parent: 32,
      },
      // Events
      {
        id: 46,
        name: "Events",
        icon: "events",
        parent: "",
        child: true,
      },
      {
        id: 461,
        name: "KSPACE Events",
        icon: "events",
        parent: 46,
        child: true,
      },
      {
        id: 471,
        icon: "eventlist",
        name: "Event List",
        path: "/event-list-kspace",
        parent: 461,
      },
      {
        id: 48,
        icon: "book",
        name: "Registrations",
        path: "/event-booking",
        parent: 461,
      },
      {
        id: 462,
        name: "Other Events",
        icon: "events",
        parent: 46,
        child: true,
      },
      {
        id: 472,
        icon: "eventlist",
        name: "Event List",
        path: "/event-list-others",
        parent: 462,
      },
      // Gallery
      {
        id: 49,
        icon: "slide",
        name: "Gallery",
        path: "",
        child: true,
        parent: "",
      },
      {
        id: 61,
        icon: "slide",
        name: "Images",
        path: "/images",
        parent: 49,
      },
      {
        id: 62,
        icon: "slide",
        name: "Videos",
        path: "/videos",
        parent: 49,
      },
      // Analytics
      {
        id: 900,
        name: "Analytics",
        icon: "settings",
        parent: "",
        child: true,
      },
      {
        id: 901,
        path: "/login-analytics",
        icon: "analytics",
        name: "Login Analytics",
        parent: 900,
      },
      {
        id: 902,
        path: "/login-logs",
        icon: "database",
        name: "Login Logs",
        parent: 900,
      },
    ],
  },
  superAdminMenu: {
    title: "ADMIN",
    menus: [
      {
        id: 0,
        name: "Dashboard",
        icon: "structure",
        parent: "",
        path: "/admin-dashboard",
      },
      // Home Page Management
      {
        id: 3,
        name: "Home Page Management",
        parent: "",
        child: true,
        icon: "house",
      },
      // About KSPACE
      {
        id: 7,
        name: "About KSPACE",
        parent: 3,
        icon: "about",
        child: true,
      },
      {
        id: 51,
        path: "/maintext-list",
        icon: "maintext",
        name: "Main Text",
        parent: 7,
      },
      {
        id: 52,
        path: "/organization-list",
        icon: "structure",
        name: "Organizational Structure",
        parent: 7,
      },
      {
        id: 8,
        path: "/quotes-list",
        icon: "quote",
        name: "Messages",
        parent: 7,
      },
      {
        id: 6,
        path: "/scope-activity-list",
        icon: "activity",
        name: "Scope of Activities",
        parent: 7,
      },
      {
        id: 9,
        path: "/accomplishment-list",
        icon: "flag",
        name: "Our Accomplishments",
        parent: 7,
      },
      // Home Page
      {
        id: 301,
        name: "Home Page",
        parent: 3,
        icon: "house",
        child: true,
      },
      {
        id: 4,
        icon: "slide",
        path: "/banner-list",
        name: "Banner Images/Videos",
        parent: 301,
      },
      {
        id: 5,
        path: "/scrolling-list",
        icon: "bell",
        name: "Scrolling Notification",
        parent: 301,
      },
      {
        id: 107,
        path: "/advertisement-list",
        icon: "flag",
        name: "Advertisement",
        parent: 301,
      },
      {
        id: 66,
        path: "/news-list",
        icon: "application",
        name: "News and Updates",
        parent: 301,
      },
      // List of Companies
      {
        id: 11,
        name: "List of Companies",
        parent: "",
        icon: "company",
        child: true,
      },
      {
        id: 15,
        name: "Existing Aerospace Companies Affiliated with KSPACE",
        path: "/kerala-companies-list",
        icon: "companylist",
        parent: 11,
      },
      {
        id: 21,
        name: "KSPACE Premises",
        icon: "companylist",
        path: "/company-request-list/kspace",
        parent: 11,
      },
      {
        id: 211,
        name: "Own Premises",
        icon: "companylist",
        path: "/company-request-list/own",
        parent: 11,
      },
      {
        id: 18,
        name: "Indian Companies",
        icon: "companylist",
        path: "/india-companies-list",
        parent: 11,
      },
      {
        id: 212,
        name: "International Companies",
        icon: "companylist",
        path: "/international-companies-list",
        parent: 11,
      },
      {
        id: 213,
        name: "On-going Projects in KSPACE Premises",
        icon: "activity",
        path: "/admin-directory-kspace/kspace",
        parent: 11,
      },
      {
        id: 214,
        name: "On-going Projects in Own Premises",
        icon: "activity",
        path: "/admin-directory-kspace/own",
        parent: 11,
      },
      {
        id: 215,
        name: "Completed Projects in KSPACE Premises",
        icon: "book",
        path: "/admin-directory-kspace/completed-kspace",
        parent: 11,
      },
      {
        id: 216,
        name: "Completed Projects in Own Premises",
        icon: "book",
        path: "/admin-directory-kspace/completed-own",
        parent: 11,
      },
      // Area Management
      {
        id: 2,
        name: "Area Management",
        icon: "areamanage",
        parent: "",
        child: true,
      },
      {
        id: 83,
        name: "Built-Up Space Category",
        icon: "areamanage",
        parent: 2,
        path: "/area-types",
      },
      {
        id: 84,
        name: "Building & Floor Details",
        icon: "areamanage",
        parent: 2,
        path: "/rent-area",
      },
      {
        id: 85,
        name: "Built-Up Space Allocation Details",
        icon: "areamanage",
        parent: 2,
        path: "/space-allocation-details",
      },
      {
        id: 86,
        name: "Land Allocation Details",
        icon: "areamanage",
        parent: 2,
        path: "/land-allocation-details",
      },
      {
        id: 80,
        name: "Built-Up Space/Land in KSPACE Premises",
        icon: "areamanage",
        parent: 2,
        path: "/builtup-space",
      },
      // Association with Professional Bodies / Institutions
      {
        id: 38,
        name: "Association with Professional Bodies / Institutions",
        icon: "academic",
        parent: "",
        child: true,
      },
      {
        id: 39,
        path: "/academicinstitution-list",
        icon: "application",
        name: "Academic Institutions",
        parent: 38,
      },
      {
        id: 42,
        path: "/institutionproposal-list",
        icon: "directory",
        name: "Student Project Proposal",
        parent: 38,
      },
      // Master Data Table
      {
        id: 10,
        name: "Master Data Table",
        parent: "",
        icon: "book",
        child: true,
      },
      {
        id: 101,
        path: "/domain-list",
        icon: "technology",
        name: "Domains (Area of Operations)",
        parent: 10,
      },
      {
        id: 102,
        path: "/qualifications-list",
        icon: "academic",
        name: "Educational Qualification",
        parent: 10,
      },
      {
        id: 103,
        path: "/tenderCategory-list",
        icon: "companylist",
        name: "Tender Category List",
        parent: 10,
      },
      {
        id: 104,
        path: "/tenderOrganization-list",
        icon: "company",
        name: "Tender Organization List",
        parent: 10,
      },
      {
        id: 105,
        path: "/techo-transfer-category-list",
        icon: "companylist",
        name: "Technology Transfer Category List",
        parent: 10,
      },
      {
        id: 106,
        path: "/techo-transfer-organization-list",
        icon: "company",
        name: "Technology Transfer Organisations List",
        parent: 10,
      },
      // KSPACE Related
      {
        id: 450,
        name: "KSPACE Related",
        parent: "",
        icon: "about",
        child: true,
      },
      {
        id: 45,
        icon: "advisors",
        path: "/advisors-list",
        name: "Spacepark Advisors",
        parent: 450,
      },
      {
        id: 23,
        path: "/resource-list",
        name: "Resource Personnel",
        icon: "resource",
        parent: 450,
      },
      {
        id: 26,
        path: "/manpower-list",
        name: "Expert Manpower",
        parent: 450,
        icon: "expert",
      },
      {
        id: 30,
        path: "/tender-list",
        icon: "application",
        name: "Tender Notices",
        parent: 450,
      },
      {
        id: 63,
        path: "/career-list",
        icon: "application",
        name: "Career Opportunities",
        parent: 450,
      },
      {
        id: 64,
        path: "/policies-list",
        name: "Policies and Regulations",
        parent: 450,
        icon: "application",
      },
      {
        id: 65,
        path: "/incentives-list",
        name: "Financial Support and Incentives",
        parent: 450,
        icon: "resource",
      },
      {
        id: 70,
        icon: "advisors",
        path: "/faq-list",
        name: "FAQ",
        parent: 450,
      },
      // Market Research
      {
        id: 29,
        name: "Market Research",
        icon: "market",
        parent: "",
        child: true,
      },
      {
        id: 40,
        path: "/trade-list",
        icon: "application",
        name: "Trade Enquiries",
        parent: 29,
      },
      {
        id: 31,
        path: "/publication-list",
        icon: "activity",
        name: "Publications",
        parent: 29,
      },
      {
        id: 34,
        path: "/transfer-proposal-list",
        icon: "technology",
        name: "Technology Transfer Proposals",
        parent: 29,
      },

      {
        id: 680,
        name: "Challenges / Opportunities",
        icon: "ideas",
        parent: 29,
        child: true,
      },
      {
        id: 681,
        path: "/challenges-add",
        icon: "ideas",
        name: "Add Challenge/Opportunity Headline",
        parent: 680,
      },
      {
        id: 682,
        path: "/challenges",
        icon: "ideas",
        name: "List of Challenges/Opportunities",
        parent: 680,
      },
      {
        id: 683,
        path: "/market-analysis",
        name: "Market Analysis",
        icon: "market",
        parent: 680,
      },
      // Internship
      {
        id: 87,
        name: "Internship",
        icon: "company",
        parent: "",
        child: true,
      },
      {
        id: 88,
        path: "/admin-internship-requests",
        icon: "news",
        name: "Requests : Companies",
        parent: 87,
      },
      {
        id: 89,
        path: "/admin-internship-applications",
        icon: "application",
        name: "Applications : Students",
        parent: 87,
      },
      {
        id: 94,
        path: "/admin-previous-applications",
        icon: "application",
        name: "Previous Applications",
        parent: 87,
      },
      {
        id: 91,
        path: "/admin-internships-doing",
        icon: "activity",
        name: "Directory of Internships Doing",
        parent: 87,
      },
      {
        id: 92,
        path: "/admin-internships-completed",
        icon: "book",
        name: "Directory of Internships Completed",
        parent: 87,
      },
      {
        id: 93,
        path: "/admin-internships-absorbed",
        icon: "resource",
        name: "Directory of Internships Absorbed",
        parent: 87,
      },
      {
        id: 95,
        path: "/admin-internship-visualization",
        icon: "analytics",
        name: "Internship Visualization",
        parent: 87,
      },
      // Jobseekers
      {
        id: 27,
        name: "Jobseekers",
        parent: "",
        child: true,
        icon: "directory",
      },
      {
        id: 271,
        path: "/candidates-list/registry",
        name: "Job Seeker Registry",
        parent: 27,
        icon: "directory",
      },
      {
        id: 28,
        path: "/profiles-list",
        name: "Job Seeker Profiles Downloaded by Companies",
        parent: 27,
        icon: "resource",
      },
      {
        id: 272,
        path: "/candidates-list/employed",
        name: "Job Seekers Employed through KSPACE",
        parent: 27,
        icon: "directory",
      },
      {
        id: 273,
        path: "/candidates-list/inactive",
        name: "Inactive Job Seeker Registrations",
        parent: 27,
        icon: "directory",
      },
      {
        id: 274,
        path: "/candidates-list/optedout",
        name: "Job Seekers Opted-Out",
        parent: 27,
        icon: "directory",
      },
      // Business Ideas
      {
        id: 32,
        name: "Business Ideas",
        icon: "ideas",
        parent: "",
        child: true,
      },
      {
        id: 661,
        icon: "advisors",
        path: "/vendors-list",
        name: "Vendors",
        parent: 32,
      },
      {
        id: 33,
        path: "/project-proposal-list",
        icon: "proposals",
        name: "Business Proposals",
        parent: 32,
      },
      // Events
      {
        id: 46,
        name: "Events",
        icon: "events",
        parent: "",
        child: true,
      },
      {
        id: 461,
        name: "KSPACE Events",
        icon: "events",
        parent: 46,
        child: true,
      },
      {
        id: 471,
        icon: "eventlist",
        name: "Event List",
        path: "/event-list-kspace",
        parent: 461,
      },
      {
        id: 48,
        icon: "book",
        name: "Registrations",
        path: "/event-booking",
        parent: 461,
      },
      {
        id: 462,
        name: "Other Events",
        icon: "events",
        parent: 46,
        child: true,
      },
      {
        id: 472,
        icon: "eventlist",
        name: "Event List",
        path: "/event-list-others",
        parent: 462,
      },

      // Our Partners
      {
        id: 500,
        name: "Our Partners",
        icon: "people",
        parent: "",
        child: true,
      },
      {
        id: 50,
        icon: "advisors",
        path: "/admin-mou",
        name: "MoUs",
        parent: 500,
      },
      {
        id: 651,
        icon: "advisors",
        path: "/membership",
        name: "Memberships",
        parent: 500,
      },
      // Gallery
      {
        id: 49,
        icon: "slide",
        name: "Gallery",
        path: "",
        child: true,
        parent: "",
      },
      {
        id: 61,
        icon: "slide",
        name: "Images",
        path: "/images",
        parent: 49,
      },
      {
        id: 62,
        icon: "slide",
        name: "Videos",
        path: "/videos",
        parent: 49,
      },
      // Bulk Email
      {
        id: 90,
        icon: "mail",
        path: "/bulk-emails",
        name: "Bulk Email",
        parent: "",
      },
      // Analytics
      {
        id: 900,
        name: "Analytics",
        icon: "settings",
        parent: "",
        child: true,
      },
      {
        id: 901,
        path: "/login-analytics",
        icon: "analytics",
        name: "Login Analytics",
        parent: 900,
      },
      {
        id: 902,
        path: "/login-logs",
        icon: "database",
        name: "Login Logs",
        parent: 900,
      },
    ],
  },
};
